module.exports = __webpack_public_path__ + "static/media/Wanderlust.0afd6265.png";